import React from "react";
import styled, { css } from "styled-components";

const ContactCard = styled.div`
	position: fixed;
	width: calc(100vw - 3rem);
	height: 2rem;
	bottom: 1rem;
	right: 1rem;
	text-align: left;
	clear: both;
	${props =>
		!props.mobile &&
		css`
			width: 198px;
			bottom: 2rem;
			right: 1rem;
		`};
`;

const Btn = styled.a`
	font-size: 1rem;
	line-height: 2rem;
	border-radius: 0.5rem;
	padding: 0.5rem 1rem;
	border-radius: 0.5rem;
	margin: 0px;
	text-decoration: none;
	background: #24909a;
	color: #fff;
	pointer-events: all;
	opacity: 1;
	font-weight: 500;
	:hover {
		opacity: 0.8;
	}
	bottom: 1rem;
	${props =>
		!props.mobile &&
		css`
			line-height: 2rem;
		`};
`;

const Contact = ({ mobile }) => {
	return (
		<ContactCard mobile={mobile}>
			<Btn data-ga-cta-contact href="https://telxius.com/en/contact/#cable/" mobile={mobile}>
				Contact us
			</Btn>
		</ContactCard>
	);
};

export default Contact;
